<div id="start" style="position: absolute; top: -100px"></div>
<div class="hero-content">
  <div class="i-am">{{ "HERO.IAM" | translate }}</div>
  <div class="main-text">
    <h1 class="name">JONAS VALTIN</h1>
    <div class="title">{{ "HERO.ROLE" | translate }}</div>
  </div>
</div>
<a href="#contact">
  <button>{{ "HERO.BUTTON" | translate }}</button>
</a>
<div class="socials">
  <span class="stroke-hero"></span>
  <a href="https://github.com/VaJoLe">
    <img src="assets/icons/Github-small.png" alt="Github" />
  </a>
  <a href="#contact">
    <img src="assets/icons/Email-small.png" alt="Email" />
  </a>
  <a href="https://de.linkedin.com/">
    <img src="assets/icons/Linkedin-small.png" alt="LinkedIn" />
  </a>
</div>
<div class="scroll">
  {{ "HERO.SCROLL" | translate }}
  <img src="assets/icons/arrow-down-line.png" alt="" />
</div>
<img class="shadow-top-left" src="assets/shadows/shadow-top-left.svg" alt="" />
<img
  class="shadow-top-right"
  src="assets/shadows/shadow-top-right.svg"
  alt=""
/>
